import { render, staticRenderFns } from "./ReceptionDetailDepartmentEditor.vue?vue&type=template&id=1b260df8&scoped=true&"
import script from "./ReceptionDetailDepartmentEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDetailDepartmentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDetailDepartmentEditor.vue?vue&type=style&index=0&id=1b260df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b260df8",
  null
  
)

export default component.exports